import * as React from "react";
import * as ReactDOM from "react-dom/client";

import App from "./App.jsx";
import "./index.css";

// Render the application
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
